import React, { PureComponent } from "react";
import { setCycleCombination } from "Actions";
import { fetchTimeSheet } from "Thunks";

import DragDropList from "../Common/DragDropList/DragDropList";

class CycleFactory extends PureComponent {
  handleRestoreOrdre = combination => {
    const { dispatch } = this.props;
    dispatch(setCycleCombination(combination));
    dispatch(fetchTimeSheet());
  };

  render() {
    const { combination } = this.props;
    return (
      <DragDropList
        items={combination && combination.length ? combination : []}
        onRestoreCycle={this.handleRestoreOrdre}
        handleCloseSideBar={this.props.handleCloseSideBar}
      />
    );
  }
}

export default CycleFactory;



// WEBPACK FOOTER //
// ./src/components/CycleFactory/CycleFactory.js